define('vspot-angular/resources/user-resource',[], function () {
    'use strict';

    return ['$resource', function ($resource) {
        // AngularJS allows us to define multiple parameters in the same portion of the URL template.
        // As long as you only use one parameter at a time, AngularJS will construct the RESTful resource properly.
        // For params, if it is prefixed with @, then the value of that parameter is extracted from the data object
        // (useful for non-GET operations). In other words, if :controller is defined, :id should not, and vice versa.
        return $resource('/api/users/:controller:id',
            {
                id: '@id',
                controller: '@controller'
            },
            {
                get: {
                    method: 'GET',
                    cache: false
                },
                /*
                 * Authenticates user and initializes a session.
                 *
                 * @param  email
                 * @param  password
                 *
                 *  @returns  Resource object. See /resources.js documentation for details
                 *            Expected return data: { status: boolean, code: string, email: string, user: object }
                 */
                login: {
                    method: 'POST',
                    params: {
                        controller: 'login' // sets up :controller to be login, therefore creating api/users/login
                    }
                },

                /**
                 * Log out the current session
                 * WARNING!
                 * THIS IS NOT A VALID API CALL, IT REDIRECTS INSTEAD OF RETURNIG A VALUE TO THE CLIENT.
                 * DO NOT ENABLE.
                 * Login.logout() is the function you are looking for.
                 */

                // logout: {
                //     method: 'GET',
                //     params: {
                //         controller: 'logout'
                //     }
                // },

                verifyFbLogin: {
                    method: 'POST',
                    params: {
                        controller: 'verify_fb_login'
                    }
                },
                verifyGoogleLogin: {
                    method: 'POST',
                    params: {
                        controller: 'verify_google_login'
                    }
                },
                /*
                 *  Updates user data. Make sure to include id in postData.
                 *
                 *  @param  postData  An object containing all the data to be updated
                 *
                 *  @returns  Resource object. See /resources.js documentation for details
                 */
                update: {
                    method: 'PUT'
                },
                /*
                 *  Sends an email with a summary of all the activities that the user
                 *  has signed up for.
                 *
                 *  @param  email  The email to send the invitation summary to
                 *
                 *  @returns  Resource object. See /resources.js documentation for details.
                 *            Expected return data: { status: boolean, code: string, num_invitations: int }
                 *            num_invitations: Number of invitations that the user has
                 */
                sendInvitations: {
                    method: 'POST',
                    params: {
                        controller: 'send_invitations_summary'
                    }
                },
                /*
                 *  Gets additional user information not attained on login.
                 *
                 *  @returns  Resource object. See /resources.js documentation for details.
                 */
                getProfile: {
                    method: 'GET',
                    cache: true,
                    params: {
                        controller: 'get_profile_info'
                    }
                },

                /*
                 *  Checks to see if a given email is valid and available.
                 *
                 *  @param  email  The email to verify
                 *
                 *  @returns  Resource object. See /resources.js documentation for details.
                 *            Expected return data: { status: boolean, code: string }
                 */
                verifyEmail: {
                    method: 'POST',
                    params: {
                        controller: 'verify_email'
                    }
                },

                verifyRegistered: {
                    method: 'POST',
                    params: {
                        controller: 'verify_registered'
                    }
                },

                /*
                 *  Resets a user's password and sends them an expiring link that allows them
                 *  to login and update the password themselves.
                 *
                 *  @param  email  The email to use to look up the account
                 *
                 *  @returns  Resource object. See /resources.js documentation for details.
                 *            Expected return data: { status: boolean, code: string }
                 */
                resetPassword: {
                    method: 'POST',
                    params: {
                        controller: 'forgot_password'
                    }
                },
                getOrganizerTypes: {
                    method: 'GET',
                    cache: true,
                    params: {
                        controller: 'get_organizer_types'
                    }
                },
                updateProfile: {
                    method: 'POST',
                    params: {
                        controller: 'put_profile_info'
                    }
                },
                getUserAssociatedSchools: {
                    method: 'POST',
                    params: {
                        controller: 'get_user_associated_schools'
                    }
                },
                getNav: {
                    method: 'GET',
                    params: {
                        controller: 'get_nav'
                    }
                },
                getSearchableArticles: {
                    method: 'GET',
                    params: {
                        controller: 'get_searchable_articles'
                    }
                }
            }
        );
    }];
});

